'use client';

import { useIntl } from 'react-intl';

export type AuthorNickNameProps = {
  authorNickName: string;
};

/**
 * Shows author nickname with prefix
 */

export const AuthorNickName = ({ authorNickName }: AuthorNickNameProps) => {
  const { formatMessage } = useIntl();

  return (
    <span>
      {`${formatMessage({
        id: 'customerReviews.reviewCard.author.prefix',
        defaultMessage: 'von',
      })} ${
        authorNickName.length > 0
          ? authorNickName
          : formatMessage({
              id: 'customerReviews.reviewCard.author.anonymous',
              defaultMessage: 'Anonym',
            })
      }`}
    </span>
  );
};
